import 'typings.d';

export const environment = {
  firebase: window.env.firebaseClientConfig,
  production: true,
  wagerApi: window.env.wagerApi,
  walletApi: window.env.walletApi,
  build: 9,
  version: '1.0.8',
  deployment: window.env.deployment,
};
